import Observable from './Observable';
export default Observable;